let accessToken = null;
let refreshToken = null;

export function getAccessToken() {
  return accessToken;
}

export function getRefreshToken() {
  return refreshToken;
}

export function setAccessToken(token) {
  accessToken = token || null;
}

export function setRefreshToken(token) {
  refreshToken = token || null;
}

export function setTokens(tokens) {
  accessToken = tokens && tokens.token ? tokens.token : null;
  refreshToken = tokens && tokens.refreshToken ? tokens.refreshToken : null;
}

export function clearSession() {
  accessToken = null;
  refreshToken = null;
}
